// extracted by mini-css-extract-plugin
module.exports = {"tabbedCarouselBlock":"tabbedCarouselBlock_tabbedCarouselBlock__D2wOc"};